import { useUnitOfMeasureTranslation } from 'support/helpers/orderForms/orderForms';
import { OrderFormProductDTO } from 'support/types';

export const ProductUnitMeasure = ({ product }: { product: OrderFormProductDTO }) => {
  const unitOfMeasure = product.unit_of_measure;

  const translatedUnit = useUnitOfMeasureTranslation({
    unitOfMeasure,
    format: 'long',
  });

  if (!unitOfMeasure) {
    return null;
  }

  return (
    <div data-testid="unit-of-measure-section" className="flex items-center justify-end gap-2 text-xs text-gray-500">
      {translatedUnit}
    </div>
  );
};
